/* ============================================================
   AMP3 collection pages. Progressive enhancement only.
   1. Labels grid cards that are also featured in the spotlights.
   2. Hides the spotlights and the "New in" strip while filters or a search are applied.
   3. Keeps the quick filter buttons' current state in step with the URL.
      The theme's filters refresh only the product section via AJAX, so
      the server-rendered intro cannot hide itself.
   4. Filters (.a3f): applied-filter tags, price bands, the drawer's count and Clear all, and collapsed groups on
      mobile. Filtering itself stays with the theme's facet-filters.js.
   5. The small arrow after the cut-off intro (Joshua, 15 Oct 2026) shows the rest of the description right there,
      copied from the full description under the grid (#about-collection), with a small up arrow to close it again.
      Jumping to the bottom didn't work: the grid loads more products as you scroll (infinite scroll), so the
      description kept moving away. Without JavaScript the link still goes to the bottom.
   ============================================================ */
(function () {
  'use strict';
  var spot = document.getElementById('a3c-spotlights');
  var ids = spot ? (spot.dataset.spotlightIds || '').split(',').filter(Boolean) : [];
  var fresh = document.querySelector('.a3c-new');

  // Quick filter buttons sit outside the part the theme re-renders, so
  // re-mark the current one from the URL: a shortcut matches when its
  // filter parameters equal the page's.
  function filterKey(search) {
    var pairs = [];
    new URLSearchParams(search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) pairs.push(key + '=' + value);
    });
    return pairs.sort().join('&');
  }
  function syncShortcuts() {
    var current = filterKey(location.search);
    document.querySelectorAll('.a3c-shortcuts a').forEach(function (a) {
      var match = filterKey(new URL(a.href, location.origin).search) === current;
      if (match) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  function labelCards() {
    ids.forEach(function (id) {
      document.querySelectorAll('.a3c-card[data-product-id="' + id + '"] .a3c-card__badges').forEach(function (box) {
        if (box.querySelector('.a3c-card__badge--spotlight')) return;
        var badge = document.createElement('span');
        badge.className = 'a3c-card__badge a3c-card__badge--spotlight';
        badge.textContent = 'In the spotlight';
        box.prepend(badge);
      });
    });
  }

  function isNarrowed() {
    var params = new URLSearchParams(location.search);
    var narrowed = false;
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'q') narrowed = true;
    });
    // Page numbers are ignored here: infinite scroll changes ?page= as the
    // shopper scrolls, and the server already omits spotlights on page 2+.
    return narrowed;
  }

  function sync() {
    if (spot) spot.hidden = isNarrowed();
    if (fresh) fresh.hidden = isNarrowed();
    labelCards();
    syncShortcuts();
  }

  // The theme updates the URL with history.pushState/replaceState after filtering.
  ['pushState', 'replaceState'].forEach(function (fn) {
    var original = history[fn];
    history[fn] = function () {
      var result = original.apply(this, arguments);
      requestAnimationFrame(sync);
      return result;
    };
  });
  window.addEventListener('popstate', sync);

  // Infinite scroll and filter refreshes add new cards.
  var results = document.getElementById('filter-results') || document.body;
  new MutationObserver(function () { requestAnimationFrame(labelCards); })
    .observe(results.parentElement || results, { childList: true, subtree: true });

  sync();

  /* ---------- Filters ---------- */
  var facets = document.getElementById('facet-filters');
  if (!facets || !facets.classList.contains('a3f')) return;

  function apply(href) {
    if (typeof facets.applyFilters !== 'function') return false;
    facets.applyFilters(new URL(href, location.origin).searchParams.toString(), null);
    return true;
  }

  // The slider is hidden, so the Min/Max boxes are the source of truth. Keep
  // keystrokes from price-range.js, which would copy the slider's values back
  // over them; facet-filters.js applies prices on 'change', not 'input'.
  document.addEventListener('input', function (e) {
    if (e.target.type === 'number' && e.target.closest && e.target.closest('.a3f-price')) e.stopPropagation();
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-a3f-remove], [data-a3f-clear]');
    if (link) {
      if (apply(link.href)) e.preventDefault();
      return;
    }
    var band = e.target.closest && e.target.closest('[data-a3f-band]');
    if (band) {
      var range = band.closest('price-range');
      var min = range.querySelector('#price-range-number-min');
      var max = range.querySelector('#price-range-number-max');
      var on = band.getAttribute('aria-pressed') === 'true';
      min.value = on ? '' : band.dataset.min;
      max.value = on ? '' : band.dataset.max;
      range.querySelector('#price-range-slider-min').value = min.value || min.min;
      range.querySelector('#price-range-slider-max').value = max.value || max.max;
      range.querySelectorAll('[data-a3f-band]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(!on && b === band));
      });
      // facet-filters.js applies price changes on 'change' events.
      max.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Drawer header count and footer Clear all live outside the re-rendered form.
  function syncDrawer() {
    var holder = facets.querySelector('[data-a3f-count]');
    var count = holder ? Number(holder.dataset.a3fCount) : 0;
    var badge = facets.querySelector('[data-a3f-head-count]');
    var clear = facets.querySelector('[data-a3f-clear]');
    if (badge) { badge.textContent = count; badge.hidden = !count; }
    if (clear) clear.hidden = !count;
  }
  document.addEventListener('on:facet-filters:updated', syncDrawer);

  // On phones and tablets the filters are a drawer: open only the groups in use.
  if (window.matchMedia('(max-width: 1023.98px)').matches) {
    facets.querySelectorAll('details.filter').forEach(function (d) {
      if (!d.classList.contains('has-active')) d.open = false;
    });
  }

  /* 5. "Read more" arrow: the full description in place (copied from #about-collection, sections/amp3-collection-copy.liquid) */
  document.addEventListener('click', function (e) {
    var more = e.target.closest ? e.target.closest('.a3c-intro__more') : null;
    if (!more) return;
    var body = document.querySelector('#about-collection .a3cc__body');
    var p = more.closest('p');
    if (!body || !p) return; // no full text on the page: follow the link
    e.preventDefault();
    var full = document.createElement('div');
    full.className = 'a3c-intro__full';
    full.innerHTML = body.innerHTML;
    var less = document.createElement('button');
    less.type = 'button';
    less.className = 'a3c-intro__less';
    less.setAttribute('aria-label', 'Show less');
    less.title = 'Show less';
    less.textContent = '↑';
    var last = full.lastElementChild; // at the end of the last paragraph, like the → on the intro
    (last && last.tagName === 'P' ? last : full).appendChild(less);
    p.hidden = true;
    p.parentNode.insertBefore(full, p.nextSibling);
    less.addEventListener('click', function () { full.parentNode.removeChild(full); p.hidden = false; more.focus(); });
  });
})();
